<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>任务列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
            <div style="margin: 10px 0;"> <el-button type="success" size="small"
                    @click.native="clickAdd">添加任务</el-button></div>
            <div style="margin-left: 2vh;">
                <el-input placeholder="请输入任务开始天数" prefix-icon="el-icon-search" size="small" v-model="day" clearable
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div>
                <el-input placeholder="请输入任务名称" prefix-icon="el-icon-search" size="small" v-model="task_name" clearable
                    @keyup.enter.native="Query"></el-input>
            </div>
            <div>
                <el-input placeholder="请输入用户任务id" prefix-icon="el-icon-search" size="small" v-model="taskId" clearable
                    @keyup.enter.native="Query" @input="handleTaskIdInput"></el-input>
            </div>
            <div>
                <el-input placeholder="请输入用户组任务id" prefix-icon="el-icon-search" size="small" v-model="groupTaskId"
                    clearable @keyup.enter.native="Query" @input="handleGroupTaskIdInput"></el-input>
            </div>
            <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置</el-button>
            </div>
            <div style="margin-left:20px;"> <el-button type="warning" size="small"
                    @click="resetFilters">重置筛选</el-button>
            </div>
        </div>
        <div class="list">
            <el-table :data="taskList" ref="taskList" style="width: 100%" :row-class-name="tableRowClassName"
                size="mini" stripe :show-summary="isStatistics" :summary-method="getSummaries">
                <el-table-column prop="task_name" label="任务名称" fixed="left" width="80" :filters="taskList1"
                    :filter-method="filterHandler1"></el-table-column>
                <el-table-column prop="category.page_name" label="资源名称"></el-table-column>
                <el-table-column prop="day" label="任务天数" width="80" :filters="taskList"
                    :filter-method="filterHandler"></el-table-column>
                <el-table-column prop="category.page_id" label="小程序id"></el-table-column>
                <el-table-column prop="category.room" label="资源分类"></el-table-column>
                <el-table-column prop="category.duration" label="时长(秒)"></el-table-column>
                <el-table-column prop="category.type" label="资源类型"></el-table-column>
                <el-table-column prop="category.difficulty_level" label="训练的难度等级"></el-table-column>
                <el-table-column prop="category.db_table" label="数据对应表名"></el-table-column>
                <el-table-column prop="category.is_test" label="是否为测试资源"></el-table-column>
                <el-table-column prop="description" label="任务描述" width="120"></el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" circle
                            @click="clickEdit(scope.$index, scope.row)"></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle
                            @click="clickDelete(scope.$index, scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 50, 80, 100]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="delTaskList">删 除</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改数据" :visible.sync="dialogModifyData">
            <el-form :model="modifyData" :rules="rules" ref="modifyData">
                <el-form-item label="资源ID" :label-width="formLabelWidth" prop="category_id">
                    <el-input v-model="modifyData.category_id" autocomplete="off" placeholder="请输入资源ID"></el-input>
                </el-form-item>
                <el-form-item label="任务名称" :label-width="formLabelWidth" prop="task_name">
                    <el-input v-model="modifyData.task_name" autocomplete="off" placeholder="请输入任务名称"></el-input>
                </el-form-item>
                <el-form-item label="第几天任务开始" :label-width="formLabelWidth" prop="day">
                    <el-input v-model="modifyData.day" autocomplete="off" placeholder="请输入任务开始的天数"></el-input>
                </el-form-item>
                <el-form-item label="任务描述" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.description" autocomplete="off" placeholder="请输入任务描述"></el-input>
                </el-form-item>
                <el-form-item label="用户组任务id" :label-width="formLabelWidth" prop="id">
                    <el-input v-model="modifyData.group_task_id" autocomplete="off" placeholder="请输入用户组任务id"></el-input>
                </el-form-item>
                <el-form-item label="用户任务id" :label-width="formLabelWidth" prop="id">
                    <el-input v-model="modifyData.task_id" autocomplete="off" placeholder="请输入用户任务id"></el-input>
                </el-form-item>
                <el-form-item label="当天任务时长" :label-width="formLabelWidth" prop="id">
                    <el-input v-model="modifyData.duration" autocomplete="off" placeholder="请输入任务时长"></el-input>
                </el-form-item>
                <el-form-item label="用户任务id" :label-width="formLabelWidth" prop="id">
                    <el-input v-model="modifyData.id" autocomplete="off" placeholder="请输入用户任务id"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogModify">取 消</el-button>
                <el-button type="primary" @click="submitFormModify">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加数据" :visible.sync="dialogAddData" width="80%" top="6vh" center @close="closeDialogAdd">
            <div class="search">
                <div>
                    <el-input placeholder="请输入内容" prefix-icon="el-icon-search" size="small" v-model="mobileKey"
                        @keyup.enter.native="QueryZY"></el-input>
                </div>
                <div style="margin-right:20px;">
                    <el-select v-model="roomType" placeholder="房间类型" size="small" clearable style="width: 220px;">
                        <el-option label="脑" value="脑"></el-option>
                        <el-option label="身" value="身"></el-option>
                        <el-option label="食" value="食"></el-option>
                        <el-option label="心" value="心"></el-option>
                    </el-select>
                </div>
                <div> <el-button type="primary" size="small" @click.native="QueryZY">查询</el-button></div>
                <div style="margin-left:20px;"> <el-button type="success" size="small"
                        @click.native="resettingZY">重置</el-button>
                </div>
            </div>
            <div class="list" style="min-height: 100px;">
                <el-table :data="taskListZY" style="width: 100%" :row-class-name="tableRowClassName" size="mini"
                    max-height="300" stripe>
                    <el-table-column prop="id" label="资源id" fixed="left" width="70"></el-table-column>
                    <el-table-column prop="room" label="资源分类"></el-table-column>
                    <el-table-column prop="page_name" label="资源名称"></el-table-column>
                    <el-table-column prop="page_id" label="小程序id"></el-table-column>
                    <el-table-column prop="duration" label="时长"></el-table-column>
                    <el-table-column prop="type" label="资源类型"></el-table-column>
                    <el-table-column prop="difficulty_level" label="训练的难度等级"></el-table-column>
                    <el-table-column prop="db_table" label="数据对应表名"></el-table-column>
                    <el-table-column prop="is_test" label="是否为测试资源"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="copyContent(scope.$index, scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination @size-change="handleSizeChangeZY" @current-change="handleCurrentChangeZY"
                        :current-page="pagesZY" :page-sizes="[10, 20, 30, 40]" :page-size="limitZY"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalZY">
                    </el-pagination>
                </div>
            </div>
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="类别ID" :label-width="formLabelWidth" prop="category_id">
                    <el-input v-model="addData.category_id" autocomplete="off" placeholder="请输入类别ID"></el-input>
                </el-form-item>
                <el-form-item label="任务名称" :label-width="formLabelWidth" prop="task_name">
                    <el-input v-model="addData.task_name" autocomplete="off" placeholder="请输入任务名称"></el-input>
                </el-form-item>
                <el-form-item label="第几天任务开始" :label-width="formLabelWidth" prop="day">
                    <el-input v-model="addData.day" autocomplete="off" placeholder="请输入任务开始的天数"></el-input>
                </el-form-item>
                <el-form-item label="任务描述" :label-width="formLabelWidth">
                    <el-input v-model="addData.description" autocomplete="off" placeholder="请输入任务描述"></el-input>
                </el-form-item>
                <el-form-item label="用户组任务id" :label-width="formLabelWidth">
                    <el-input v-model="addData.group_task_id" autocomplete="off" placeholder="请输入用户组任务id"></el-input>
                </el-form-item>
                <el-form-item label="用户任务id" :label-width="formLabelWidth">
                    <el-input v-model="addData.task_id" autocomplete="off" placeholder="请输入用户任务id"></el-input>
                </el-form-item>
                <!-- <el-form-item label="当天任务时长" :label-width="formLabelWidth">
                    <el-input v-model="addData.duration" autocomplete="off" placeholder="请输入任务时长"></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mobileKey: '',
            pages: 1,
            limit: 10,
            taskList: [],
            total: 0,
            dialogDelete: false,
            clickObject: {},
            dialogModifyData: false,
            modifyData: {
                category_id: '',
                task_name: '',
                day: '',
                description: '',
                id: '',
                group_task_id: '',
                task_id: '',
                duration: '',
                list: []
            },
            formLabelWidth: '150px',
            dialogAddData: false,
            addData: {
                category_id: '',
                task_name: '',
                day: '',
                description: '', // 任务描述
                group_task_id: '',
                task_id: '',
                duration: '', // 任务时长
                list: []
            },
            rules: {
                category_id: [
                    { required: true, message: '类别id为必填项', trigger: 'change' }
                ],
                task_name: [
                    { required: true, message: '任务名称为必填项', trigger: 'blur' }
                ],
                day: [
                    { required: true, message: '任务天数为必填项', trigger: 'change' }
                ]
            },
            delData: {},
            pagesZY: 1,
            limitZY: 10,
            taskListZY: [],
            totalZY: 0,
            day: '',
            task_name: '',
            taskList1: [],
            isStatistics: false,
            groupTaskId: '',
            taskId: '',
            roomType: ''
        }
    },
    created() {
        this.taskId = this.$route.query.taskId || '';
        this.groupTaskId = this.$route.query.groupTaskId || '';
        this.getTaskList();
    },
    methods: {
        // 用户任务id和任务组id不能同时存在
        handleTaskIdInput(val) {
            if (val) this.groupTaskId = ''; // 输入taskId时清空groupTaskId
        },
        handleGroupTaskIdInput(val) {
            if (val) this.taskId = ''; // 输入groupTaskId时清空taskId
        },
        QueryZY() {
            this.pagesZY = 1
            this.getTaskListZY()
        },
        resettingZY() {
            this.pagesZY = 1
            this.mobileKey = this.roomType = ''
            this.getTaskListZY()
        },
        getTaskListZY() {
            this.$get(`/v1/admin/category_table?pages=${this.pagesZY}&limit=${this.limitZY}&key=${this.mobileKey}&room=${this.roomType}`, {})
                .then((res) => {
                    if (res.data.status === 'success') {
                        this.taskListZY = res.data.data.data;
                        this.totalZY = res.data.total;
                    } else {
                        this.$msg(res.data.msg);
                    }
                });
        },
        tableRowClassName({ row, rowIndex }) {
            return rowIndex % 2 === 1 ? '' : 'success-row';
        },
        getTaskList() {
            const params = new URLSearchParams();
            params.append('pages', this.pages);
            params.append('limit', this.limit);

            if (this.day) params.append('day', this.day);
            if (this.task_name) params.append('task_name', encodeURIComponent(this.task_name));

            // 确保group_task_id和task_id不同时存在
            if (this.groupTaskId) params.append('group_task_id', this.groupTaskId);
            if (this.taskId) params.append('task_id', this.taskId);

            this.$get(`/v1/task_table?${params}`, {})
                .then((res) => {
                    if (res.data.status === 'success') {
                        const resData = res.data.data.data;
                        this.taskList = resData.map(item => ({ ...item, text: item.day, value: item.day }));
                        this.taskList1 = resData.map(item => ({ ...item, text: item.task_name, value: item.task_name }));
                        this.total = res.data.total;
                    } else {
                        this.$msg(res.data.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.limit = val;
            this.getTaskList();
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getTaskList();
        },
        handleSizeChangeZY(val) {
            this.limitZY = val;
            this.getTaskListZY();
        },
        handleCurrentChangeZY(val) {
            this.pagesZY = val;
            this.getTaskListZY();
        },
        clickEdit(index, row) {
            console.log(row, 'rowrow')
            this.modifyData = {
                category_id: row.category.id,
                task_name: row.task_name,
                day: row.day,
                description: row.description,
                id: row.id,
                group_task_id: row.group_task_id,
                task_id: row.task_id,
                duration: row.category.duration
            };
            this.dialogModifyData = true;
        },
        clickDelete(index, row) {
            this.dialogDelete = true;
            this.delData = { id: row.id };
        },
        delTaskList() {
            this.$delete(`/v1/task_table?id=${this.delData.id}`, {})
                .then((res) => {
                    if (res.data.status === 'success') {
                        this.$message.success('删除成功');
                        this.getTaskList();
                        this.dialogDelete = false;
                    } else {
                        this.$msg(res.data.msg);
                    }
                });
        },
        clickAdd() {
            this.getTaskListZY();
            this.addData.task_id = this.taskId || ''; // 路由中的 taskId 赋值给用户任务id输入框
            this.addData.group_task_id = this.groupTaskId || ''; // 路由中的 groupTaskId 赋值给用户组任务id输入框
            this.dialogAddData = true;
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    const totalDuration = this.addData.list.reduce((sum, item) => {
                        return sum + (item.duration || 0); // 假设资源对象中 duration 字段存储时长
                    }, 0);
                    this.addTaskList(this.addData, totalDuration);
                } else {
                    this.$message.error('表单验证失败!');
                    return false;
                }
            });
        },
        addTaskList(data, timer) {
            const idList = [...new Set(data.category_id.split(","))];
            const baseData = {};

            // 前3个必填项，直接添加（即使为空也保留，按业务需求）
            baseData.task_name = data.task_name;
            baseData.day = +data.day;
            baseData.duration = Number(timer);

            // 后3个可选属性：值不为空（null/undefined/空字符串）时才添加
            if (data.description) {
                baseData.description = data.description;
            }
            if (data.group_task_id) {
                baseData.group_task_id = Number(data.group_task_id);
            }
            // 关键修改：使用 data.task_id（表单中的值）而非 this.taskId
            if (data.task_id) {
                baseData.task_id = Number(data.task_id);
            }

            const callApi = (currentId) => {
                const apiData = { ...baseData, category_id: +currentId };
                console.log(apiData, 'apiData')
                return this.$post('/v1/task_table', apiData);
            };
            const handleResponse = (index) => {
                if (index >= idList.length) {
                    this.getTaskList();
                    this.dialogAddData = false;
                    return;
                }

                callApi(idList[index])
                    .then((res) => {
                        if (res.data.status === 'success') {
                            if (index === idList.length - 1) {
                                this.$message.success('添加成功');
                            }
                            handleResponse(index + 1);
                        } else {
                            throw new Error(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.$msg(error.message || '添加失败');
                    });
            };

            handleResponse(0);
        },
        closeDialogAdd() {
            this.dialogAddData = false;
            this.addData = {
                category_id: '',
                task_name: '',
                day: '',
                description: '',
                group_task_id: '', // 重置用户组任务id
                task_id: '', // 重置用户任务id
                list: []
            };
            this.mobileKey = '';
            this.roomType = '';
        },
        closeDialogModify() {
            this.dialogModifyData = false;
            this.modifyData = { category_id: '', task_name: '', day: '', description: '', id: '' };
        },
        submitFormModify() {
            this.$refs.modifyData.validate((valid) => {
                if (valid) {
                    const apiData = {
                        id: this.modifyData.id,
                        category_id: this.modifyData.category_id,
                        task_name: this.modifyData.task_name,
                        day: this.modifyData.day,
                        description: this.modifyData.description
                    };

                    // 过滤空值字段
                    Object.keys(apiData).forEach(key => apiData[key] === '' && delete apiData[key]);

                    this.$put('/v1/task_table', apiData)
                        .then((res) => {
                            if (res.data.status === 'success') {
                                this.$message.success('修改成功');
                                this.getTaskList();
                                this.dialogModifyData = false;
                            } else {
                                this.$msg(res.data.msg);
                            }
                        })
                        .catch((error) => {
                            this.$msg('修改失败: ' + error.message);
                        });
                } else {
                    console.log('表单验证失败!');
                    return false;
                }
            });
        },
        copyContent(index, row) {
            this.addData.list.push(row);
            // 简单拼接 category_id，可根据实际需求调整，比如去重、格式处理等
            const ids = this.addData.list.map(item => item.id).join(',');
            this.addData.category_id = ids;
        },
        resetting() {
            this.day = this.task_name = this.groupTaskId = this.taskId = '';
            this.getTaskList();
        },
        Query() {
            this.pages = 1;
            this.getTaskList();
        },
        filterHandler(value, row, column) {
            this.isStatistics = true;
            return row[column.property] === value;
        },
        filterHandler1(value, row, column) {
            this.isStatistics = true;
            return row[column.property] === value;
        },
        getSummaries({ columns, data }) {
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总时长统计';
                } else if (index === 5) {
                    const totalDuration = data.reduce((sum, row) => sum + row.category.duration, 0);
                    let min = totalDuration / 60;
                    if (min % 1 !== 0) {
                        min = min.toFixed(2);
                    } else {
                        min = Math.floor(min);
                    }
                    sums[index] = `${min} 分钟`;
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        resetFilters() {
            this.isStatistics = false;
            this.$refs.taskList.clearFilter();
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        flex-wrap wrap
        align-items center
        justify-content flex-start
        input
          width 180px
          margin-right 10px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>


// WEBPACK FOOTER //
// src/pages/taskData/taskData.vue